var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconSignOut = function SvgIconSignOut(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.719 15.008 2.187-2.188H7.82v-1.64h8.086L13.72 8.992l1.21-1.172L19.07 12l-4.14 4.18zM17.82 4.5q.704 0 1.172.508.508.468.508 1.172v3.867l-1.68-1.64V6.18H6.18v11.64h11.64v-2.226l1.68-1.64v3.866q0 .704-.508 1.211-.468.47-1.172.469H6.18q-.743 0-1.211-.469a1.72 1.72 0 0 1-.469-1.21V6.18q0-.743.469-1.211.468-.47 1.21-.469z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconSignOut);
export { ForwardRef as ReactComponent };